import Logger from 'core/utils/Logger'

import { ITranslations } from '../models'

export const prepareTranslations = (translations: unknown): ITranslations => {
  const isTranslationsString = typeof translations === 'string'
  if (isTranslationsString) {
    try {
      return JSON.parse(translations as string)
    } catch (e) {
      Logger.error('Failed to parse translations JSON', e)
      return {}
    }
  }

  return translations as ITranslations
}
